const DEV = process.env.REACT_APP_API_HOST || "http://localhost:7777/api/v1/";
// const PRODUCTION = "http://localhost:7777/api/v1/";

export const API_DOMAIN = DEV;
export const UPLOAD_FILES_URL = `${API_DOMAIN.replace(/\/+$/, "")}/files/upload-files`;
